import { combineReducers } from "redux";
import map from "./map";
import menu from "./menu";

export default combineReducers({
    map,
    menu
});